// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoriaHubSection_root__jvyK9","list":"CategoriaHubSection_list__U5cNe","rotation":"CategoriaHubSection_rotation__YEeYr"};